import React, { Component } from 'react';
import Card, { CardContent, CardHeader } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import Typography from 'material-ui/Typography';
import TextField from 'material-ui/TextField';
import SendIcon from 'material-ui-icons/Send';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import { db } from '../ThirdPartyIntegration/firebaseClient'
import { config } from '../config';


class Conversation extends Component {
    constructor(props) {
        super(props);

        let conversationId = props.params.id;

        let userJsonString = window.localStorage.getItem(config.localstorage.userKey);
        let user = JSON.parse(userJsonString);

        this.state = {
            user: user,
            conversationId: conversationId,
            messages: [],
            currentMessage: ''
        }

        let that = this;

        db.ref('conversations/' + conversationId).once('value').then(function (snapshot) {
            let covnersation = snapshot.val();
            let userId1 = covnersation.userId1;
            let userId2 = covnersation.userId2;

            db.ref('users/' + userId1 + '/info').once('value').then(function (snapshot) {
                that.setState({ [userId1]: snapshot.val() });
            })

            db.ref('users/' + userId2 + '/info').once('value').then(function (snapshot) {
                that.setState({ [userId2]: snapshot.val() });
            })
        });

        this.onClickSendMessage = this.onClickSendMessage.bind(this);
        this.onChangeMessage = this.onChangeMessage.bind(this);
    }

    timeDifference(current, previous) {

        var msPerMinute = 60 * 1000;
        var msPerHour = msPerMinute * 60;
        var msPerDay = msPerHour * 24;
        var msPerMonth = msPerDay * 30;
        var msPerYear = msPerDay * 365;

        var elapsed = current - previous;

        if (elapsed < msPerMinute) {
            return Math.round(elapsed / 1000) + ' seconds ago';
        }

        else if (elapsed < msPerHour) {
            return Math.round(elapsed / msPerMinute) + ' minutes ago';
        }

        else if (elapsed < msPerDay) {
            return Math.round(elapsed / msPerHour) + ' hours ago';
        }

        else if (elapsed < msPerMonth) {
            return 'approximately ' + Math.round(elapsed / msPerDay) + ' days ago';
        }

        else if (elapsed < msPerYear) {
            return 'approximately ' + Math.round(elapsed / msPerMonth) + ' months ago';
        }

        else {
            return 'approximately ' + Math.round(elapsed / msPerYear) + ' years ago';
        }
    }

    componentDidMount() {
        var that = this;

        // load all messages from tbe conversation and display them as cards.
        // continue to update them as they show up.
        var messagesRef = db.ref('conversations/' + this.state.conversationId + '/messages');
        messagesRef.on('value', function (snapshot) {
            let messages = snapshot.val();
            console.log('new message: ');
            console.log(messages)
            if (messages) {
                that.setState({
                    messages: messages
                })
            }
        });

        this.scrollToBottom();
    }

    componentDidUpdate() {
        this.scrollToBottom();
      }

    onClickSendMessage() {
        var newMessageKey = db.ref('conversations/' + this.state.conversationId + '/messages').push().key;

        var newMessage = {
            from: this.state.user.uid,
            at: Date.now(),
            contents: this.state.currentMessage
        }

        console.log(newMessage);

        var updates = {};
        updates['conversations/' + this.state.conversationId + '/messages/' + newMessageKey] = newMessage;

        db.ref().update(updates);

        this.setState({ currentMessage: '' });
    }

    onChangeMessage(e) {
        let v = e.target.value;
        this.setState({
            currentMessage: v
        })
    }

    scrollToBottom = () => {
        this.refs.messagesEnd.scrollIntoView({ behavior: "smooth" });
      }

    render() {
        const styles = {
            messageText: {
                width: '100%',
                overflowY: 'scroll',
                marginLeft: '5px',
                height: '80%'
            },
            sendButton: {
                textAlign: 'right',
                marginLeft: '5px'
            },
            messageBox: {
                background: 'rgba(255,255,255,0.9)',
                marginTop: '10px',
                position: 'fixed',
                bottom: '10px',
                width: '100%',
                height: '15%'
            },
            chatMessages: {
                height: '50%',
                overflowY: 'scroll',
                marginBottom: '25%'
            },
            sendButtonContainer: {
                textAlign: 'center'
            }
        }
        return (
            <div>
                <div style={styles.chatMessages}>
                    {Object.entries(this.state.messages).map(value =>
                        <Card key={value[0]}>
                            <CardHeader
                                avatar={
                                    <Avatar alt={this.state[value[1].from].username} src={this.state[value[1].from].picture} />
                                }
                                title={this.state[value[1].from].username}
                                subheader={this.timeDifference(Date.now(), value[1].at)}
                            />
                            <CardContent>
                                <Typography component="p">
                                    {value[1].contents}
                                </Typography>
                            </CardContent>
                        </Card>
                    )}
                    <div style={{ float: "left", clear: "both" }}
                        ref='messagesEnd'>
                    </div>
                </div>
                <Grid container style={styles.messageBox}>
                    <Grid item xs={9} style={styles.messageTextContainer}>
                        <TextField
                            label="Say something"
                            multiline
                            style={styles.messageText}
                            value={this.state.currentMessage}
                            onChange={this.onChangeMessage}
                        />
                    </Grid>
                    <Grid item xs={3} style={styles.sendButtonContainer}>
                        <Button onClick={this.onClickSendMessage} fab color="accent" aria-label="edit" style={styles.sendButton}>
                            <SendIcon />
                        </Button>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default Conversation;


// WEBPACK FOOTER //
// ./src/Components/Conversation.jsx